var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "189pt",
    height: "72pt",
    viewBox: "0 0 189 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.65625 -6.625 C 4.734375 -6.921875 4.78125 -6.984375 4.90625 -7.03125 C 5 -7.046875 5.359375 -7.046875 5.59375 -7.046875 C 6.703125 -7.046875 7.1875 -7 7.1875 -6.15625 C 7.1875 -5.984375 7.140625 -5.5625 7.09375 -5.28125 C 7.09375 -5.234375 7.0625 -5.109375 7.0625 -5.078125 C 7.0625 -5 7.09375 -4.921875 7.203125 -4.921875 C 7.3125 -4.921875 7.34375 -5.015625 7.359375 -5.1875 L 7.65625 -7.078125 C 7.671875 -7.125 7.671875 -7.234375 7.671875 -7.265625 C 7.671875 -7.390625 7.5625 -7.390625 7.390625 -7.390625 L 1.328125 -7.390625 C 1.0625 -7.390625 1.0625 -7.375 0.984375 -7.171875 L 0.328125 -5.25 C 0.3125 -5.21875 0.265625 -5.078125 0.265625 -5.046875 C 0.265625 -4.984375 0.3125 -4.921875 0.390625 -4.921875 C 0.5 -4.921875 0.515625 -4.984375 0.578125 -5.15625 C 1.171875 -6.84375 1.453125 -7.046875 3.0625 -7.046875 L 3.484375 -7.046875 C 3.796875 -7.046875 3.796875 -7 3.796875 -6.921875 C 3.796875 -6.84375 3.765625 -6.71875 3.75 -6.6875 L 2.296875 -0.859375 C 2.1875 -0.453125 2.15625 -0.34375 1 -0.34375 C 0.59375 -0.34375 0.53125 -0.34375 0.53125 -0.125 C 0.53125 0 0.65625 0 0.71875 0 C 1.015625 0 1.3125 -0.015625 1.609375 -0.015625 C 1.921875 -0.015625 2.234375 -0.03125 2.546875 -0.03125 C 2.84375 -0.03125 3.15625 -0.015625 3.453125 -0.015625 C 3.765625 -0.015625 4.09375 0 4.390625 0 C 4.5 0 4.640625 0 4.640625 -0.21875 C 4.640625 -0.34375 4.546875 -0.34375 4.265625 -0.34375 C 3.984375 -0.34375 3.84375 -0.34375 3.5625 -0.359375 C 3.25 -0.390625 3.15625 -0.421875 3.15625 -0.59375 C 3.15625 -0.609375 3.15625 -0.671875 3.203125 -0.828125 Z M 4.65625 -6.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.296875 -4.484375 L 4.375 -6.65625 C 4.34375 -6.734375 4.3125 -6.78125 4.3125 -6.796875 C 4.3125 -6.859375 4.5 -7.0625 4.96875 -7.109375 C 5.078125 -7.125 5.1875 -7.125 5.1875 -7.3125 C 5.1875 -7.453125 5.046875 -7.453125 5.015625 -7.453125 C 4.5625 -7.453125 4.09375 -7.421875 3.640625 -7.421875 C 3.375 -7.421875 2.6875 -7.453125 2.421875 -7.453125 C 2.359375 -7.453125 2.21875 -7.453125 2.21875 -7.234375 C 2.21875 -7.109375 2.328125 -7.109375 2.46875 -7.109375 C 3.125 -7.109375 3.203125 -7 3.296875 -6.765625 L 4.578125 -3.71875 L 2.28125 -1.25 L 2.140625 -1.125 C 1.609375 -0.546875 1.09375 -0.375 0.53125 -0.34375 C 0.390625 -0.328125 0.296875 -0.328125 0.296875 -0.125 C 0.296875 -0.109375 0.296875 0 0.4375 0 C 0.765625 0 1.125 -0.03125 1.46875 -0.03125 C 1.859375 -0.03125 2.296875 0 2.6875 0 C 2.75 0 2.875 0 2.875 -0.21875 C 2.875 -0.328125 2.765625 -0.34375 2.75 -0.34375 C 2.65625 -0.34375 2.3125 -0.375 2.3125 -0.671875 C 2.3125 -0.84375 2.46875 -1.03125 2.609375 -1.171875 L 3.71875 -2.34375 L 4.703125 -3.40625 L 5.796875 -0.8125 C 5.84375 -0.6875 5.859375 -0.671875 5.859375 -0.65625 C 5.859375 -0.5625 5.65625 -0.375 5.21875 -0.34375 C 5.109375 -0.328125 5 -0.3125 5 -0.125 C 5 0 5.125 0 5.171875 0 C 5.46875 0 6.234375 -0.03125 6.546875 -0.03125 C 6.8125 -0.03125 7.484375 0 7.75 0 C 7.828125 0 7.96875 0 7.96875 -0.203125 C 7.96875 -0.34375 7.859375 -0.34375 7.765625 -0.34375 C 7.03125 -0.34375 7.015625 -0.375 6.828125 -0.8125 C 6.40625 -1.828125 5.671875 -3.53125 5.421875 -4.1875 C 6.15625 -4.953125 7.3125 -6.25 7.65625 -6.546875 C 7.96875 -6.8125 8.390625 -7.078125 9.046875 -7.109375 C 9.1875 -7.125 9.28125 -7.125 9.28125 -7.328125 C 9.28125 -7.34375 9.28125 -7.453125 9.140625 -7.453125 C 8.8125 -7.453125 8.453125 -7.421875 8.109375 -7.421875 C 7.703125 -7.421875 7.296875 -7.453125 6.90625 -7.453125 C 6.84375 -7.453125 6.703125 -7.453125 6.703125 -7.234375 C 6.703125 -7.15625 6.75 -7.125 6.828125 -7.109375 C 6.921875 -7.09375 7.265625 -7.078125 7.265625 -6.765625 C 7.265625 -6.625 7.140625 -6.484375 7.0625 -6.375 Z M 5.296875 -4.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.515625 -6.203125 L 6.65625 -6.359375 C 6.984375 -6.6875 7.34375 -7.0625 8.09375 -7.109375 C 8.21875 -7.125 8.3125 -7.125 8.3125 -7.3125 C 8.3125 -7.40625 8.25 -7.453125 8.171875 -7.453125 C 7.890625 -7.453125 7.5625 -7.421875 7.28125 -7.421875 C 6.921875 -7.421875 6.53125 -7.453125 6.1875 -7.453125 C 6.125 -7.453125 5.984375 -7.453125 5.984375 -7.234375 C 5.984375 -7.125 6.078125 -7.109375 6.140625 -7.109375 C 6.21875 -7.109375 6.53125 -7.09375 6.53125 -6.859375 C 6.53125 -6.671875 6.28125 -6.390625 6.234375 -6.34375 L 3.703125 -3.421875 L 2.515625 -6.65625 C 2.4375 -6.8125 2.4375 -6.84375 2.4375 -6.84375 C 2.4375 -7.109375 2.984375 -7.109375 3.09375 -7.109375 C 3.234375 -7.109375 3.34375 -7.109375 3.34375 -7.328125 C 3.34375 -7.453125 3.21875 -7.453125 3.1875 -7.453125 C 2.875 -7.453125 2.109375 -7.421875 1.8125 -7.421875 C 1.53125 -7.421875 0.859375 -7.453125 0.59375 -7.453125 C 0.53125 -7.453125 0.375 -7.453125 0.375 -7.234375 C 0.375 -7.109375 0.484375 -7.109375 0.625 -7.109375 C 1.28125 -7.109375 1.328125 -7.015625 1.421875 -6.734375 L 2.765625 -3.15625 C 2.78125 -3.125 2.8125 -3 2.8125 -2.96875 C 2.8125 -2.9375 2.375 -1.171875 2.328125 -0.984375 C 2.1875 -0.375 2.171875 -0.34375 1.296875 -0.34375 C 1.09375 -0.34375 1 -0.34375 1 -0.125 C 1 0 1.140625 0 1.15625 0 C 1.46875 0 2.21875 -0.03125 2.53125 -0.03125 C 2.828125 -0.03125 3.625 0 3.921875 0 C 4 0 4.140625 0 4.140625 -0.21875 C 4.140625 -0.34375 4.03125 -0.34375 3.828125 -0.34375 C 3.8125 -0.34375 3.59375 -0.34375 3.40625 -0.359375 C 3.1875 -0.375 3.125 -0.40625 3.125 -0.53125 C 3.125 -0.609375 3.21875 -1 3.265625 -1.21875 L 3.65625 -2.765625 C 3.703125 -2.96875 3.71875 -3 3.8125 -3.09375 Z M 6.515625 -6.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.625 -7.453125 C 5.625 -7.453125 5.625 -7.5625 5.484375 -7.5625 C 5.328125 -7.5625 4.28125 -7.46875 4.09375 -7.453125 C 4.015625 -7.4375 3.953125 -7.390625 3.953125 -7.234375 C 3.953125 -7.109375 4.046875 -7.109375 4.203125 -7.109375 C 4.734375 -7.109375 4.75 -7.03125 4.75 -6.921875 L 4.71875 -6.703125 L 4.0625 -4.125 C 3.875 -4.53125 3.5625 -4.828125 3.0625 -4.828125 C 1.78125 -4.828125 0.4375 -3.21875 0.4375 -1.625 C 0.4375 -0.59375 1.03125 0.125 1.890625 0.125 C 2.109375 0.125 2.65625 0.078125 3.296875 -0.703125 C 3.390625 -0.234375 3.78125 0.125 4.296875 0.125 C 4.671875 0.125 4.921875 -0.125 5.109375 -0.484375 C 5.296875 -0.875 5.4375 -1.53125 5.4375 -1.5625 C 5.4375 -1.671875 5.328125 -1.671875 5.296875 -1.671875 C 5.1875 -1.671875 5.1875 -1.625 5.140625 -1.46875 C 4.96875 -0.765625 4.765625 -0.125 4.3125 -0.125 C 4.03125 -0.125 3.984375 -0.40625 3.984375 -0.625 C 3.984375 -0.890625 4.015625 -0.953125 4.0625 -1.140625 Z M 3.359375 -1.296875 C 3.296875 -1.09375 3.296875 -1.078125 3.140625 -0.890625 C 2.65625 -0.296875 2.21875 -0.125 1.90625 -0.125 C 1.359375 -0.125 1.203125 -0.71875 1.203125 -1.140625 C 1.203125 -1.6875 1.5625 -3.03125 1.8125 -3.53125 C 2.15625 -4.171875 2.640625 -4.578125 3.078125 -4.578125 C 3.78125 -4.578125 3.9375 -3.6875 3.9375 -3.625 C 3.9375 -3.5625 3.921875 -3.484375 3.90625 -3.4375 Z M 3.359375 -1.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.859375 1.859375 C 1.8125 2 1.796875 2.015625 1.796875 2.078125 C 1.796875 2.3125 2 2.375 2.109375 2.375 C 2.171875 2.375 2.40625 2.34375 2.515625 2.09375 C 2.546875 2 2.609375 1.640625 2.90625 0.09375 C 3 0.109375 3.078125 0.125 3.265625 0.125 C 5.078125 0.125 6.75 -1.59375 6.75 -3.3125 C 6.75 -4.171875 6.328125 -4.828125 5.5 -4.828125 C 3.921875 -4.828125 3.265625 -2.703125 2.625 -0.578125 C 1.4375 -0.796875 0.828125 -1.40625 0.828125 -2.1875 C 0.828125 -2.5 1.078125 -3.703125 1.734375 -4.453125 C 1.828125 -4.546875 1.828125 -4.5625 1.828125 -4.59375 C 1.828125 -4.640625 1.796875 -4.703125 1.6875 -4.703125 C 1.390625 -4.703125 0.546875 -3.125 0.546875 -2.078125 C 0.546875 -1.046875 1.265625 -0.25 2.4375 0.015625 Z M 3.359375 -0.515625 C 3.265625 -0.515625 3.25 -0.515625 3.15625 -0.53125 C 3.03125 -0.53125 3.015625 -0.53125 3.015625 -0.5625 C 3.015625 -0.59375 3.203125 -1.578125 3.234375 -1.75 C 3.578125 -3.140625 4.421875 -4.1875 5.40625 -4.1875 C 6.15625 -4.1875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -1.84375 5.03125 -0.515625 3.359375 -0.515625 Z M 3.359375 -0.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4 -4.359375 L 4.9375 -4.359375 C 5.15625 -4.359375 5.265625 -4.359375 5.265625 -4.578125 C 5.265625 -4.703125 5.15625 -4.703125 4.96875 -4.703125 L 4.0625 -4.703125 L 4.296875 -5.9375 C 4.34375 -6.171875 4.5 -6.953125 4.5625 -7.078125 C 4.65625 -7.28125 4.84375 -7.453125 5.078125 -7.453125 C 5.109375 -7.453125 5.40625 -7.453125 5.609375 -7.25 C 5.125 -7.203125 5.015625 -6.828125 5.015625 -6.65625 C 5.015625 -6.40625 5.21875 -6.28125 5.421875 -6.28125 C 5.703125 -6.28125 6.015625 -6.515625 6.015625 -6.9375 C 6.015625 -7.4375 5.515625 -7.6875 5.078125 -7.6875 C 4.703125 -7.6875 4.015625 -7.5 3.6875 -6.40625 C 3.625 -6.1875 3.59375 -6.078125 3.328125 -4.703125 L 2.578125 -4.703125 C 2.359375 -4.703125 2.25 -4.703125 2.25 -4.5 C 2.25 -4.359375 2.34375 -4.359375 2.546875 -4.359375 L 3.265625 -4.359375 L 2.453125 -0.046875 C 2.25 1 2.078125 2 1.5 2 C 1.46875 2 1.1875 2 0.984375 1.796875 C 1.484375 1.765625 1.578125 1.375 1.578125 1.203125 C 1.578125 0.953125 1.390625 0.828125 1.171875 0.828125 C 0.890625 0.828125 0.578125 1.0625 0.578125 1.484375 C 0.578125 1.96875 1.0625 2.234375 1.5 2.234375 C 2.109375 2.234375 2.546875 1.59375 2.734375 1.171875 C 3.09375 0.484375 3.34375 -0.828125 3.34375 -0.90625 Z M 4 -4.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.125 -7.453125 C 3.125 -7.453125 3.125 -7.5625 2.984375 -7.5625 C 2.734375 -7.5625 1.9375 -7.484375 1.65625 -7.453125 C 1.578125 -7.453125 1.453125 -7.4375 1.453125 -7.234375 C 1.453125 -7.109375 1.546875 -7.109375 1.71875 -7.109375 C 2.234375 -7.109375 2.25 -7.03125 2.25 -6.921875 L 2.21875 -6.703125 L 0.640625 -0.421875 C 0.59375 -0.265625 0.59375 -0.25 0.59375 -0.1875 C 0.59375 0.0625 0.8125 0.125 0.921875 0.125 C 1.09375 0.125 1.265625 -0.015625 1.3125 -0.15625 L 1.53125 -1 L 1.765625 -1.96875 C 1.828125 -2.21875 1.890625 -2.453125 1.953125 -2.703125 C 1.96875 -2.765625 2.0625 -3.125 2.078125 -3.203125 C 2.109375 -3.296875 2.4375 -3.90625 2.8125 -4.203125 C 3.046875 -4.375 3.390625 -4.578125 3.859375 -4.578125 C 4.328125 -4.578125 4.453125 -4.203125 4.453125 -3.8125 C 4.453125 -3.234375 4.03125 -2.046875 3.78125 -1.375 C 3.6875 -1.125 3.625 -1 3.625 -0.78125 C 3.625 -0.265625 4.015625 0.125 4.53125 0.125 C 5.546875 0.125 5.953125 -1.46875 5.953125 -1.5625 C 5.953125 -1.671875 5.859375 -1.671875 5.828125 -1.671875 C 5.71875 -1.671875 5.71875 -1.640625 5.65625 -1.46875 C 5.5 -0.890625 5.140625 -0.125 4.546875 -0.125 C 4.359375 -0.125 4.28125 -0.234375 4.28125 -0.484375 C 4.28125 -0.75 4.390625 -1.015625 4.484375 -1.25 C 4.65625 -1.71875 5.140625 -3.015625 5.140625 -3.65625 C 5.140625 -4.359375 4.71875 -4.828125 3.890625 -4.828125 C 3.203125 -4.828125 2.6875 -4.484375 2.28125 -3.984375 Z M 3.125 -7.453125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.25 -7.28125 C 5.265625 -7.328125 5.296875 -7.390625 5.296875 -7.453125 C 5.296875 -7.5625 5.21875 -7.5625 5.15625 -7.5625 C 5.046875 -7.5625 5.03125 -7.546875 5 -7.34375 L 3.1875 -0.140625 C 2.359375 -0.234375 1.9375 -0.640625 1.9375 -1.359375 C 1.9375 -1.578125 1.9375 -1.859375 2.53125 -3.390625 C 2.578125 -3.515625 2.65625 -3.703125 2.65625 -3.921875 C 2.65625 -4.421875 2.296875 -4.828125 1.75 -4.828125 C 0.71875 -4.828125 0.3125 -3.234375 0.3125 -3.140625 C 0.3125 -3.03125 0.421875 -3.03125 0.453125 -3.03125 C 0.5625 -3.03125 0.5625 -3.046875 0.625 -3.234375 C 0.921875 -4.265625 1.359375 -4.578125 1.71875 -4.578125 C 1.8125 -4.578125 2 -4.578125 2 -4.234375 C 2 -3.953125 1.890625 -3.671875 1.75 -3.296875 C 1.21875 -1.921875 1.21875 -1.640625 1.21875 -1.453125 C 1.21875 -0.421875 2.078125 0.03125 3.125 0.09375 C 3.03125 0.484375 3.03125 0.515625 2.875 1.09375 C 2.84375 1.203125 2.625 2.09375 2.625 2.125 C 2.625 2.140625 2.625 2.234375 2.765625 2.234375 C 2.78125 2.234375 2.828125 2.234375 2.859375 2.1875 C 2.890625 2.171875 2.953125 1.890625 2.984375 1.75 L 3.40625 0.125 C 3.8125 0.125 4.765625 0.125 5.796875 -1.046875 C 6.234375 -1.546875 6.46875 -2.03125 6.59375 -2.359375 C 6.6875 -2.625 6.921875 -3.578125 6.921875 -4.0625 C 6.921875 -4.671875 6.625 -4.828125 6.453125 -4.828125 C 6.171875 -4.828125 5.90625 -4.53125 5.90625 -4.296875 C 5.90625 -4.15625 5.96875 -4.09375 6.0625 -4 C 6.1875 -3.875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -2.375 5.890625 -1.484375 5.5 -1.09375 C 4.546875 -0.125 3.84375 -0.125 3.453125 -0.125 Z M 5.25 -7.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4 -3.171875 C 3.640625 -3.09375 3.625 -2.78125 3.625 -2.75 C 3.625 -2.578125 3.765625 -2.453125 3.9375 -2.453125 C 4.109375 -2.453125 4.375 -2.59375 4.375 -2.9375 C 4.375 -3.390625 3.875 -3.515625 3.578125 -3.515625 C 3.21875 -3.515625 2.90625 -3.25 2.71875 -2.9375 C 2.546875 -3.359375 2.140625 -3.515625 1.8125 -3.515625 C 0.9375 -3.515625 0.453125 -2.515625 0.453125 -2.296875 C 0.453125 -2.21875 0.515625 -2.1875 0.578125 -2.1875 C 0.671875 -2.1875 0.6875 -2.234375 0.703125 -2.328125 C 0.890625 -2.90625 1.375 -3.296875 1.78125 -3.296875 C 2.09375 -3.296875 2.25 -3.0625 2.25 -2.78125 C 2.25 -2.625 2.15625 -2.25 2.09375 -2 C 2.03125 -1.765625 1.859375 -1.0625 1.8125 -0.90625 C 1.703125 -0.484375 1.421875 -0.140625 1.0625 -0.140625 C 1.03125 -0.140625 0.828125 -0.140625 0.65625 -0.25 C 1.015625 -0.34375 1.015625 -0.671875 1.015625 -0.6875 C 1.015625 -0.875 0.875 -0.984375 0.703125 -0.984375 C 0.484375 -0.984375 0.25 -0.796875 0.25 -0.5 C 0.25 -0.125 0.640625 0.078125 1.046875 0.078125 C 1.46875 0.078125 1.765625 -0.234375 1.90625 -0.5 C 2.09375 -0.109375 2.453125 0.078125 2.84375 0.078125 C 3.703125 0.078125 4.1875 -0.921875 4.1875 -1.140625 C 4.1875 -1.21875 4.125 -1.25 4.0625 -1.25 C 3.96875 -1.25 3.953125 -1.1875 3.921875 -1.109375 C 3.765625 -0.578125 3.3125 -0.140625 2.859375 -0.140625 C 2.59375 -0.140625 2.40625 -0.3125 2.40625 -0.65625 C 2.40625 -0.8125 2.453125 -1 2.5625 -1.4375 C 2.609375 -1.6875 2.78125 -2.375 2.828125 -2.53125 C 2.9375 -2.953125 3.21875 -3.296875 3.578125 -3.296875 C 3.625 -3.296875 3.828125 -3.296875 4 -3.171875 Z M 4 -3.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.125 -3 C 4.15625 -3.109375 4.15625 -3.125 4.15625 -3.1875 C 4.15625 -3.390625 4 -3.4375 3.90625 -3.4375 C 3.859375 -3.4375 3.6875 -3.421875 3.578125 -3.21875 C 3.5625 -3.171875 3.484375 -2.890625 3.453125 -2.71875 L 2.96875 -0.8125 C 2.96875 -0.78125 2.625 -0.140625 2.046875 -0.140625 C 1.65625 -0.140625 1.515625 -0.4375 1.515625 -0.78125 C 1.515625 -1.25 1.78125 -1.953125 1.96875 -2.421875 C 2.046875 -2.625 2.078125 -2.6875 2.078125 -2.84375 C 2.078125 -3.28125 1.71875 -3.515625 1.359375 -3.515625 C 0.5625 -3.515625 0.234375 -2.390625 0.234375 -2.296875 C 0.234375 -2.21875 0.296875 -2.1875 0.359375 -2.1875 C 0.46875 -2.1875 0.46875 -2.234375 0.5 -2.3125 C 0.703125 -3.015625 1.046875 -3.296875 1.328125 -3.296875 C 1.453125 -3.296875 1.515625 -3.21875 1.515625 -3.03125 C 1.515625 -2.859375 1.453125 -2.671875 1.40625 -2.53125 C 1.078125 -1.6875 0.9375 -1.28125 0.9375 -0.90625 C 0.9375 -0.125 1.53125 0.078125 2 0.078125 C 2.375 0.078125 2.640625 -0.09375 2.84375 -0.265625 C 2.71875 0.171875 2.640625 0.484375 2.34375 0.875 C 2.078125 1.1875 1.765625 1.40625 1.40625 1.40625 C 1.265625 1.40625 0.96875 1.375 0.8125 1.140625 C 1.234375 1.109375 1.265625 0.75 1.265625 0.703125 C 1.265625 0.515625 1.109375 0.40625 0.953125 0.40625 C 0.765625 0.40625 0.5 0.546875 0.5 0.9375 C 0.5 1.3125 0.84375 1.625 1.40625 1.625 C 2.21875 1.625 3.125 0.96875 3.375 0.015625 Z M 4.125 -3 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.296875 -4.96875 C 3.296875 -5.125 3.171875 -5.28125 2.984375 -5.28125 C 2.734375 -5.28125 2.53125 -5.046875 2.53125 -4.84375 C 2.53125 -4.6875 2.65625 -4.546875 2.84375 -4.546875 C 3.078125 -4.546875 3.296875 -4.765625 3.296875 -4.96875 Z M 1.625 0.390625 C 1.5 0.890625 1.109375 1.40625 0.625 1.40625 C 0.5 1.40625 0.375 1.375 0.359375 1.359375 C 0.609375 1.25 0.640625 1.03125 0.640625 0.953125 C 0.640625 0.765625 0.5 0.65625 0.328125 0.65625 C 0.109375 0.65625 -0.109375 0.859375 -0.109375 1.125 C -0.109375 1.421875 0.1875 1.625 0.640625 1.625 C 1.125 1.625 2 1.328125 2.234375 0.359375 L 2.953125 -2.484375 C 2.984375 -2.578125 3 -2.640625 3 -2.765625 C 3 -3.203125 2.640625 -3.515625 2.1875 -3.515625 C 1.34375 -3.515625 0.84375 -2.40625 0.84375 -2.296875 C 0.84375 -2.21875 0.90625 -2.1875 0.96875 -2.1875 C 1.046875 -2.1875 1.0625 -2.21875 1.109375 -2.328125 C 1.359375 -2.890625 1.765625 -3.296875 2.15625 -3.296875 C 2.328125 -3.296875 2.421875 -3.171875 2.421875 -2.921875 C 2.421875 -2.8125 2.40625 -2.6875 2.375 -2.578125 Z M 1.625 0.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.328125 -5.296875 C 2.328125 -5.3125 2.359375 -5.40625 2.359375 -5.421875 C 2.359375 -5.453125 2.328125 -5.53125 2.234375 -5.53125 C 2.203125 -5.53125 1.953125 -5.5 1.765625 -5.484375 L 1.328125 -5.453125 C 1.140625 -5.4375 1.0625 -5.4375 1.0625 -5.296875 C 1.0625 -5.171875 1.171875 -5.171875 1.28125 -5.171875 C 1.65625 -5.171875 1.65625 -5.125 1.65625 -5.0625 C 1.65625 -5.03125 1.65625 -5.015625 1.625 -4.875 L 0.484375 -0.34375 C 0.453125 -0.21875 0.453125 -0.171875 0.453125 -0.171875 C 0.453125 -0.03125 0.5625 0.078125 0.71875 0.078125 C 0.984375 0.078125 1.046875 -0.171875 1.078125 -0.28125 C 1.15625 -0.625 1.375 -1.46875 1.453125 -1.796875 C 1.890625 -1.75 2.4375 -1.609375 2.4375 -1.140625 C 2.4375 -1.109375 2.4375 -1.0625 2.421875 -0.984375 C 2.390625 -0.890625 2.375 -0.765625 2.375 -0.734375 C 2.375 -0.265625 2.71875 0.078125 3.1875 0.078125 C 3.515625 0.078125 3.734375 -0.171875 3.828125 -0.3125 C 4.03125 -0.609375 4.15625 -1.09375 4.15625 -1.140625 C 4.15625 -1.21875 4.09375 -1.25 4.03125 -1.25 C 3.9375 -1.25 3.921875 -1.1875 3.890625 -1.046875 C 3.78125 -0.671875 3.578125 -0.140625 3.203125 -0.140625 C 3 -0.140625 2.953125 -0.3125 2.953125 -0.53125 C 2.953125 -0.640625 2.953125 -0.734375 3 -0.921875 C 3 -0.953125 3.03125 -1.078125 3.03125 -1.15625 C 3.03125 -1.8125 2.21875 -1.953125 1.8125 -2.015625 C 2.109375 -2.1875 2.375 -2.46875 2.46875 -2.5625 C 2.90625 -3 3.265625 -3.296875 3.65625 -3.296875 C 3.75 -3.296875 3.84375 -3.265625 3.90625 -3.1875 C 3.484375 -3.125 3.484375 -2.75 3.484375 -2.75 C 3.484375 -2.578125 3.625 -2.453125 3.796875 -2.453125 C 4.015625 -2.453125 4.25 -2.625 4.25 -2.953125 C 4.25 -3.234375 4.0625 -3.515625 3.65625 -3.515625 C 3.203125 -3.515625 2.78125 -3.15625 2.328125 -2.703125 C 1.859375 -2.25 1.671875 -2.171875 1.53125 -2.109375 Z M 2.328125 -5.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.921875 -3.421875 L 3.3125 -3.421875 L 4.953125 -0.890625 C 5.0625 -0.71875 5.328125 -0.296875 5.4375 -0.125 C 5.515625 0 5.546875 0 5.796875 0 L 7.3125 0 C 7.5 0 7.671875 0 7.671875 -0.203125 C 7.671875 -0.28125 7.609375 -0.359375 7.5 -0.375 C 7.09375 -0.46875 6.5625 -1.1875 6.296875 -1.53125 C 6.234375 -1.640625 5.6875 -2.359375 4.953125 -3.546875 C 5.921875 -3.71875 6.859375 -4.140625 6.859375 -5.4375 C 6.859375 -6.953125 5.25 -7.46875 3.96875 -7.46875 L 0.546875 -7.46875 C 0.34375 -7.46875 0.171875 -7.46875 0.171875 -7.28125 C 0.171875 -7.09375 0.375 -7.09375 0.46875 -7.09375 C 1.09375 -7.09375 1.140625 -7.015625 1.140625 -6.46875 L 1.140625 -1 C 1.140625 -0.453125 1.09375 -0.375 0.46875 -0.375 C 0.375 -0.375 0.171875 -0.375 0.171875 -0.203125 C 0.171875 0 0.34375 0 0.546875 0 L 3.53125 0 C 3.734375 0 3.890625 0 3.890625 -0.203125 C 3.890625 -0.375 3.703125 -0.375 3.59375 -0.375 C 2.96875 -0.375 2.921875 -0.46875 2.921875 -1 Z M 5.03125 -3.953125 C 5.328125 -4.359375 5.359375 -4.9375 5.359375 -5.421875 C 5.359375 -5.9375 5.296875 -6.515625 4.953125 -6.96875 C 5.40625 -6.875 6.484375 -6.53125 6.484375 -5.4375 C 6.484375 -4.71875 6.15625 -4.171875 5.03125 -3.953125 Z M 2.921875 -6.5 C 2.921875 -6.734375 2.921875 -7.09375 3.59375 -7.09375 C 4.53125 -7.09375 4.984375 -6.703125 4.984375 -5.421875 C 4.984375 -4.015625 4.640625 -3.8125 2.921875 -3.8125 Z M 1.4375 -0.375 C 1.53125 -0.578125 1.53125 -0.890625 1.53125 -0.984375 L 1.53125 -6.484375 C 1.53125 -6.59375 1.53125 -6.890625 1.4375 -7.09375 L 2.6875 -7.09375 C 2.546875 -6.921875 2.546875 -6.703125 2.546875 -6.53125 L 2.546875 -0.984375 C 2.546875 -0.875 2.546875 -0.578125 2.625 -0.375 Z M 3.765625 -3.421875 C 3.84375 -3.4375 3.875 -3.453125 3.96875 -3.453125 C 4.140625 -3.453125 4.375 -3.46875 4.53125 -3.484375 C 4.703125 -3.234375 5.875 -1.28125 6.78125 -0.375 L 5.71875 -0.375 Z M 3.765625 -3.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.109375 -3.78125 C 2.15625 -3.875 2.1875 -3.9375 2.1875 -4.015625 C 2.1875 -4.28125 1.9375 -4.453125 1.71875 -4.453125 C 1.40625 -4.453125 1.3125 -4.171875 1.28125 -4.0625 L 0.265625 -0.625 C 0.234375 -0.53125 0.234375 -0.515625 0.234375 -0.5 C 0.234375 -0.4375 0.28125 -0.421875 0.359375 -0.390625 C 0.515625 -0.328125 0.53125 -0.328125 0.546875 -0.328125 C 0.5625 -0.328125 0.609375 -0.328125 0.671875 -0.46875 Z M 2.109375 -3.78125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.890625 -2.546875 C 3.890625 -3.390625 3.8125 -3.90625 3.546875 -4.421875 C 3.203125 -5.125 2.546875 -5.296875 2.109375 -5.296875 C 1.109375 -5.296875 0.734375 -4.546875 0.625 -4.328125 C 0.34375 -3.75 0.328125 -2.953125 0.328125 -2.546875 C 0.328125 -2.015625 0.34375 -1.21875 0.734375 -0.578125 C 1.09375 0.015625 1.6875 0.171875 2.109375 0.171875 C 2.5 0.171875 3.171875 0.046875 3.578125 -0.734375 C 3.875 -1.3125 3.890625 -2.03125 3.890625 -2.546875 Z M 2.109375 -0.0625 C 1.84375 -0.0625 1.296875 -0.1875 1.125 -1.015625 C 1.03125 -1.46875 1.03125 -2.21875 1.03125 -2.640625 C 1.03125 -3.1875 1.03125 -3.75 1.125 -4.1875 C 1.296875 -5 1.90625 -5.078125 2.109375 -5.078125 C 2.375 -5.078125 2.9375 -4.9375 3.09375 -4.21875 C 3.1875 -3.78125 3.1875 -3.171875 3.1875 -2.640625 C 3.1875 -2.171875 3.1875 -1.453125 3.09375 -1 C 2.921875 -0.171875 2.375 -0.0625 2.109375 -0.0625 Z M 2.109375 -0.0625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.453125 -6.59375 C 2.453125 -6.984375 2.484375 -7.109375 3.34375 -7.109375 L 3.625 -7.109375 L 3.625 -7.453125 C 3.25 -7.421875 2.390625 -7.421875 1.96875 -7.421875 C 1.546875 -7.421875 0.6875 -7.421875 0.3125 -7.453125 L 0.3125 -7.109375 L 0.59375 -7.109375 C 1.453125 -7.109375 1.484375 -6.984375 1.484375 -6.59375 L 1.484375 -0.84375 C 1.484375 -0.453125 1.453125 -0.34375 0.59375 -0.34375 L 0.3125 -0.34375 L 0.3125 0 C 0.6875 -0.03125 1.546875 -0.03125 1.96875 -0.03125 C 2.390625 -0.03125 3.25 -0.03125 3.625 0 L 3.625 -0.34375 L 3.34375 -0.34375 C 2.484375 -0.34375 2.453125 -0.453125 2.453125 -0.84375 Z M 2.453125 -6.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.140625 -0.59375 L 4.140625 0.125 L 5.75 0 L 5.75 -0.34375 C 4.984375 -0.34375 4.890625 -0.421875 4.890625 -0.953125 L 4.890625 -7.5625 L 3.328125 -7.453125 L 3.328125 -7.109375 C 4.09375 -7.109375 4.171875 -7.03125 4.171875 -6.5 L 4.171875 -4.140625 C 3.859375 -4.53125 3.390625 -4.828125 2.796875 -4.828125 C 1.515625 -4.828125 0.375 -3.75 0.375 -2.34375 C 0.375 -0.953125 1.4375 0.125 2.6875 0.125 C 3.375 0.125 3.875 -0.25 4.140625 -0.59375 Z M 4.140625 -3.515625 L 4.140625 -1.28125 C 4.140625 -1.09375 4.140625 -1.0625 4.03125 -0.890625 C 3.703125 -0.359375 3.203125 -0.125 2.734375 -0.125 C 2.25 -0.125 1.859375 -0.40625 1.59375 -0.8125 C 1.3125 -1.265625 1.28125 -1.890625 1.28125 -2.328125 C 1.28125 -2.734375 1.296875 -3.390625 1.609375 -3.875 C 1.84375 -4.21875 2.25 -4.578125 2.84375 -4.578125 C 3.234375 -4.578125 3.6875 -4.421875 4.03125 -3.921875 C 4.140625 -3.734375 4.140625 -3.71875 4.140625 -3.515625 Z M 4.140625 -3.515625 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 74.085,
    y: 16.887
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 80.46,
    y: 18.523
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 85.725,
    y: 16.887
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 157.437,
    y: 16.887
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 163.812,
    y: 18.523
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 168.782,
    y: 16.887
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 0.007,
    y: 60.742
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 7.886,
    y: 56.784
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 78.722,
    y: 60.742
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 86.6,
    y: 56.784
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 160.989,
    y: 60.742
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 168.867,
    y: 56.784
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -72.671437 -16.382719 L -19.913625 13.011813 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 70.597656 21.894531 L 67.039062 22.054688 L 68.859375 22.867188 L 68.589844 24.839844 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 21.969,
    y: 30.32
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 27.647187,
    y: 30.32
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 34.784,
    y: 26.361
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 34.784,
    y: 33.243
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -72.671437 -21.929594 L -15.878469 -21.929594 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 74.886719 57.808594 L 71.699219 56.214844 L 72.894531 57.808594 L 71.699219 59.402344 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 40.495,
    y: 69.218
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 44.434276,
    y: 69.218
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 10.680125 21.929781 L 62.836375 21.929781 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 153.601562 13.949219 L 150.414062 12.355469 L 151.609375 13.949219 L 150.414062 15.546875 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 119.295,
    y: 7.995
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 123.151367,
    y: 7.995
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 128.496,
    y: 9.631
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -3.921437 -13.984281 L -3.921437 11.988375 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 84.851562 21.894531 L 83.257812 25.085938 L 84.851562 23.890625 L 86.445312 25.085938 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 88.687,
    y: 38.606
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 94.365187,
    y: 38.606
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 101.502,
    y: 40.243
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 6.043406 -21.929594 L 66.387156 -21.929594 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 157.15625 57.808594 L 153.964844 56.214844 L 155.160156 57.808594 L 153.964844 59.402344 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 117.638,
    y: 69.218
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 123.316187,
    y: 69.218
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 129.601,
    y: 70.854
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 78.715281 -13.984281 L 78.715281 11.988375 ",
    transform: "matrix(1,0,0,-1,88.773,35.879)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 167.488281 21.894531 L 165.894531 25.085938 L 167.488281 23.890625 L 169.082031 25.085938 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 171.323,
    y: 38.606
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 177.001187,
    y: 38.606
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 184.107,
    y: 40.243
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.2f752a21df6b426626cc3ff18cfdeda4.svg";
export { ForwardRef as ReactComponent };